import React from 'react'
import {findDOMNode} from "react-dom"

// @ts-ignore
import onClickOutsideHOC from "../../../lib/onclickoutside"

type Props = {
    tetherOptions?  : any
    popoverProps?   : any

    onClickOutside  : func
    onKeyDown?      : func

    children?       : any
}

export default onClickOutsideHOC(class PopoverContainer extends React.Component<Props> {

    private debounceOnClickOutside: any

    constructor(props: Props) {
        super(props)

        const delay = this.props.popoverProps.clickOutsideDelay ? this.props.popoverProps.clickOutsideDelay : 0
        this.debounceOnClickOutside = _.debounce(this.props.onClickOutside, delay)
    }

    componentWillUnmount() {
        if (this.debounceOnClickOutside) this.debounceOnClickOutside.cancel()
    }

    handleClickOutside(evt: any) {
        if (gd.utils.Dom.findNodeByClassName(findDOMNode(this), ["is-hidden"])) return

        this.debounceOnClickOutside(evt)
    }

    render() {
        let styles = this.props.popoverProps.style ? this.props.popoverProps.style : {}
        if (this.props.popoverProps.fitTargetWidth) {
            styles.minWidth = this.props.tetherOptions.target.clientWidth
        }

        return (
            <div className="popover-container" onKeyDown={this.props.onKeyDown} style={styles}>
                {this.props.children}
            </div>
        )
    }
})
